"use client";
import { Icon, RadioButton, Tooltip, Typography } from "@kyan/ui";
import Link from "next/link";

import { EstimatedExecPrice } from "#/components/EstimatedExecPrice/EstimatedExecPrice";
import { TradeFee } from "#/components/TradeFee/TradeFee";
import { routes } from "#/config/routes";

import { FocusableSizeInput } from "../../../../../FocusableSizeInput/FocusableSizeInput";
import { usePerpMarketOrderController } from "./PerpMarketOrder.controller";

export const PerpMarketOrder: React.FC = () => {
  const {
    isSm,
    perpUnit,
    perpUnits,
    sizeError,
    percentages,
    sizeWarning,
    slippageValue,
    isCustomSlippage,
    perpSizeInputValue,
    marketSubOrderTypes,
    perpMarketOrderType,
    sizeDisplayPrecision,
    isUnderlyingSelected,
    setPerpUnit,
    handleUpdateSlippage,
    handleUpdatePerpSize,
    handleToggleSubOrderType,
  } = usePerpMarketOrderController();

  return (
    <div className="flex flex-col gap-2">
      <FocusableSizeInput
        selectProps={{
          defaultValue: perpUnit,
          value: perpUnit,
          items: perpUnits,
          itemClassName: "h-8 sm:h-4",
          onValueChange: setPerpUnit,
        }}
        inputProps={{
          label: isUnderlyingSelected ? "Size" : "$ Size",
          value: perpSizeInputValue,
          error: sizeError || sizeWarning,
          /* warning: sizeWarning, */
          placeholder: isUnderlyingSelected ? "0.00" : "$0",
          rightLabel: "Equity: 500 USDC",
          autoNumericOptions: {
            currencySymbol: isUnderlyingSelected ? "" : "$",
            decimalPlaces: sizeDisplayPrecision,
          },
          onChange: handleUpdatePerpSize,
        }}
      />
      <div className="flex w-full items-center justify-between">
        <div className="flex h-4 items-center gap-1">
          <Typography primary size={12}>
            Max Slippage
          </Typography>
          <Tooltip
            content={
              <div className="grid gap-2">
                <Typography size={12}>Go to settings page to</Typography>
                <Link href={routes.portfolio.settings + "#slippage"}>
                  <Typography
                    size={12}
                    className="text-brandBlue hover:text-primary transition-colors"
                  >
                    Manage slippage
                  </Typography>
                </Link>
              </div>
            }
          >
            <div>
              <Icon size="sm" name="question" hoverEffect="circle" />
            </div>
          </Tooltip>
        </div>
        {isCustomSlippage ? (
          <div className="flex h-7 items-center gap-4">
            <Link
              href={routes.portfolio.settings + "#slippage"}
              className="text-primary decoration-primary text-xs hover:underline"
            >
              Custom
            </Link>
            <Typography grotesk>{`${slippageValue} %`}</Typography>
          </div>
        ) : (
          <RadioButton
            size="md"
            className="gap-1.5"
            items={percentages}
            value={slippageValue}
            onChange={handleUpdateSlippage}
          />
        )}
      </div>
      <EstimatedExecPrice kind="perps" type="market" />
      <TradeFee instrumentType="perps" />
      <div className="border-divider mt-2.5 flex items-center justify-between border-b pb-2">
        <Typography grotesk primary size={12}>
          Market order type
        </Typography>
        <RadioButton
          variant="tertiary"
          size={isSm ? "sm" : "md"}
          items={marketSubOrderTypes}
          value={perpMarketOrderType}
          onChange={handleToggleSubOrderType}
        />
      </div>
    </div>
  );
};
